import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theme';
// import { ElevateBadge } from './Badge';
import { ReactComponent as FilterIcon } from '../../../svg/Filter26.svg';
import t from '@jetshop/intl';
import { elementPressAnimation } from '../../ui/animations/elementPressAnimation';

const FacetsButtonWrapper = styled('button')`
  --button-foreground-color: ${theme.colors.black};
  --button-background-color: ${theme.colors.white};

  background: var(--button-background-color);
  color: var(--button-foreground-color);
  border: 1px solid var(--button-foreground-color);
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  line-height: 1;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;

  svg {
    width: 16px;
    height: 16px;
    color: inherit;
  }

  :hover {
    --button-background-color: ${theme.colors.black};
    --button-foreground-color: ${theme.colors.white};
  }
`;

export const ElevateFacetsButton = ({ nrOfActiveFacets, openFacets }) => {
  return (
    <FacetsButtonWrapper onClick={openFacets} className={elementPressAnimation}>
      <FilterIcon /> {t('Filters and sorting')}
      {nrOfActiveFacets > 0 && <span>({nrOfActiveFacets})</span>}
      {/* {nrOfActiveFacets > 0 && <ElevateBadge text={nrOfActiveFacets} />} */}
    </FacetsButtonWrapper>
  );
};
